import { RefreshCw, Search } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const PayrollEmployeesToolbar = ({
  employeeDirectory,
  activeEmployeeFiltersCount,
  employeeSearchQuery,
  onEmployeeSearchChange,
  employeeStatusFilter,
  onEmployeeStatusChange,
  employeeSortField,
  onEmployeeSortFieldChange,
  employeeSortDirection,
  onEmployeeSortDirectionChange,
  employeeSortOptions = [],
  onClearFilters,
}) => (
  <Card className="overflow-hidden rounded-xl border-slate-200 shadow-sm" data-testid="payroll-employees-toolbar-card">
    <CardContent className="space-y-2 p-3">
      <div className="flex flex-wrap items-center gap-1.5 text-xs" data-testid="payroll-employees-kpi-strip">
        <Badge variant="outline" className="rounded-full bg-green-50 text-green-700">Completos: {employeeDirectory.eligible}</Badge>
        <Badge variant="outline" className="rounded-full bg-amber-50 text-amber-700">Incompletos: {employeeDirectory.incomplete}</Badge>
        <Badge variant="outline" className="rounded-full bg-white">Total: {employeeDirectory.total}</Badge>
        {activeEmployeeFiltersCount > 0 && <Badge variant="outline" className="rounded-full bg-slate-100">{activeEmployeeFiltersCount} filtro(s)</Badge>}
      </div>

      <div className="flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-white/90 p-2 shadow-sm" data-testid="payroll-employees-controls">
        <div className="relative min-w-[220px] flex-[1.2]">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input
            placeholder="Pesquisar funcionário, número ou cargo..."
            value={employeeSearchQuery}
            onChange={(event) => onEmployeeSearchChange(event.target.value)}
            className="h-8 rounded-lg border-slate-200 bg-slate-50 pl-9 text-sm"
            data-testid="payroll-employee-search-input"
          />
        </div>

        <Select value={employeeStatusFilter} onValueChange={onEmployeeStatusChange}>
          <SelectTrigger className="h-8 w-[148px] rounded-lg border-slate-200 bg-slate-50 text-sm" data-testid="payroll-employee-status-filter">
            <SelectValue placeholder="Dossier" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos</SelectItem>
            <SelectItem value="complete">Completo</SelectItem>
            <SelectItem value="incomplete">Incompleto</SelectItem>
          </SelectContent>
        </Select>

        <Select value={employeeSortField} onValueChange={onEmployeeSortFieldChange}>
          <SelectTrigger className="h-8 w-[156px] rounded-lg border-slate-200 bg-slate-50 text-sm" data-testid="payroll-employee-sort-field">
            <SelectValue placeholder="Ordenar" />
          </SelectTrigger>
          <SelectContent>
            {employeeSortOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={employeeSortDirection} onValueChange={onEmployeeSortDirectionChange}>
          <SelectTrigger className="h-8 w-[96px] rounded-lg border-slate-200 bg-slate-50 text-sm" data-testid="payroll-employee-sort-direction">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="asc">Asc.</SelectItem>
            <SelectItem value="desc">Desc.</SelectItem>
          </SelectContent>
        </Select>

        {activeEmployeeFiltersCount > 0 && (
          <Button variant="ghost" size="sm" onClick={onClearFilters} className="h-8 rounded-lg border border-slate-200 bg-slate-50 px-2 text-slate-700 hover:bg-slate-100" data-testid="payroll-employee-clear-filters-button">
            <RefreshCw className="h-4 w-4" />
          </Button>
        )}
      </div>
    </CardContent>
  </Card>
);